export default function sendMail(selector) {
  let formData = new FormData($(selector).get(0));
  return fetch('/wp-content/themes/geterotica/assets/files/teacher-form.php', {
    method: 'POST',
    body: formData
  });
};